module.exports = __webpack_public_path__ + "0af5d249/img/ion_calendar-number.3ac5bd07.svg";